import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import StudentsPage from '../views/StudentsPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: HomePage },
  { path: '/students', component: StudentsPage },
]

export default new VueRouter({
  mode: 'history',
  routes,
})
